import React from 'react';
import { PropTypes } from 'prop-types';
import { TextInput } from '../FormInputs';
import Icon from '../Icons/Icon';

const SearchByKeyword = ({
  shouldExpand = false, params, setParams,
}) => {
  return (
    <div className="relative text-left h-full justify-between w-full justify-center mb-3">
      <div className="flex w-full">
        <h2 className="text-base font-bold mb-2 flex-1">Search Sites</h2>
        <button
          type="button"
          className="py-2 text-sm text-vamos-gray focus:outline-none"
          onClick={() => { shouldExpand(false); }}
          onKeyDown={(e) => e.key === 'Enter' && shouldExpand(false)}
        >
          <Icon name="expanded" />
        </button>
      </div>
      <TextInput
        name="searchSiteName"
        value={params.name}
        setValue={v => setParams(prev => ({ ...prev, name: v }))}
        placeholder="Keyword"
        className="w-full"
        inputHeight="h-10"
        shouldFocus
        dataTestId="site-name-input"
      />
    </div>

  );
};

export default SearchByKeyword;

SearchByKeyword.propTypes = {
  shouldExpand: PropTypes.bool,
  params: PropTypes.array.isRequired,
  setParams: PropTypes.func.isRequired,
};
